export const ALM_WEB_COMPONENT_ELEMENTS = {
  ALM_VERIFICATOR_WIDGET: 'alm-verificator-widget',
};
